import PropTypes from "prop-types";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import makeStyles from "@material-ui/core/styles/makeStyles";

import { Toast } from "common/context/toast/toast";
import { detailsToastStyles } from "common/context/toast/details-toast-styles";

const useStyles = makeStyles(detailsToastStyles);

export function DetailsToast({
  isOpen,
  type,
  message,
  onClose: handleClose,
  isExpanded,
  details,
  toggleDetails,
}) {
  const classes = useStyles();

  return (
    <Toast isOpen={isOpen} onClose={handleClose} type={type} message={message}>
      {details === "" ? null : (
        <Accordion
          className={classes.toastContent}
          expanded={isExpanded}
          onChange={toggleDetails}
        >
          <AccordionSummary
            expandIcon={
              <span className={classes.expansionToggle}>
                <Typography variant="overline">
                  {isExpanded ? "Hide" : "View"} details
                </Typography>
                {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </span>
            }
            aria-controls="toast-details-content"
            id="toast-details-header"
          >
            <Typography>{message}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={classes.expansionDetails}>
              {details}
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}
    </Toast>
  );
}

DetailsToast.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(["error", "warning", "success", "normal"]).isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  details: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  toggleDetails: PropTypes.func.isRequired,
};
